// extracted by mini-css-extract-plugin
module.exports = {"tag_base":"tag_base--LDOF1Ynv"};